import config from '../utils/config';
import ResourceManager from './resource.manager';

class TeamMembersService extends ResourceManager {
	async getTeamMembers(params?): Promise<any> {
		return await this.getResource(config.URIs.get_team_members, { params });
	}
	async getTeamMembersForBackoffice(companyId) {
		return await this.getResource(config.URIs.get_team_members_for_backoffice.replace(/:companyId/g, companyId));
	}

	async inviteTeamMembers(members) {
		if (!Array.isArray(members)) members = [members];
		return await this.postResource(config.URIs.invite_team_members, {
			invitations: members
		});
	}

	async inviteTeamMember(member) {
		return await this.postResource(config.URIs.invite_team_members, member);
	}

	async getTeamMembersInvitations(): Promise<any> {
		return await this.getResource(config.URIs.get_team_members_invitations);
	}

	async resendTeamMemberInvitation(invitationId): Promise<any> {
		return await this.putResource(
			config.URIs.resend_team_member_invitation.replace(/:invitationId/g, invitationId),
			{}
		);
	}

	async changeTeamMemberActiveState(member, activeState) {
		const url = config.URIs.team_members_change_active_state;
		return await this.putResource(url, { memberId: member, activeState });
	}

	async changeTeamMemberRole(member, role) {
		const url = config.URIs.team_members_change_role;
		return await this.putResource(url, { memberId: member, role });
	}
}

export default new TeamMembersService();
